import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import BACKEND_URL from '../config'; // Adjust path if needed

const AdminLogin = () => {
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setError('');

    try {
      const res = await axios.post(`${BACKEND_URL}/api/admin/login`, { password });
      const token = res.data.token;

      if (!token) {
        setError('❌ Token not received from server');
        return;
      }

      navigate('/warranty', { state: { token } }); // 🔁 pass token to Warranty
    } catch (err) {
      console.error('🔴 Login error:', err.response?.data || err.message);
      if (err.response?.status === 401) {
        setError('❌ Incorrect password');
      } else {
        setError('❌ Server error. Try again later.');
      }
    }
  };

  return (
    <div className="container mt-5">
      <h2 className="text-center text-warning mb-4">Admin Login</h2>
      <form onSubmit={handleLogin} className="border p-4 rounded bg-light shadow-sm">
        <div className="mb-3">
          <label className="form-label">Enter Admin Password</label>
          <input
            type="password"
            className="form-control"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
        </div>
        <button className="btn btn-warning w-100">Login</button>
        {error && <div className="alert alert-danger mt-3 text-center">{error}</div>}
      </form>
    </div>
  );
};

export default AdminLogin;
